// @flow

import baseSchema, {
  findDependentAlertTypeSchema,
  findSchemaPropertyByName,
  findSchemaRequired,
  baseUiSchema,
} from "./base-schema";
import type { Schemas } from "./types";

export const schema = (schema: ?Object) => {
  const typeSchema = findDependentAlertTypeSchema(
    schema,
    "X_DAY_TYPE_OVER_Z_SPELLS_IN_Y_PERIOD_TYPE",
  );

  return {
    ...baseSchema,
    properties: {
      ...baseSchema.properties,
      xDayTypeOverZSpellsInYPeriodType: {
        required: findSchemaRequired(typeSchema, "xDayTypeOverZSpellsInYPeriodType"),
        title: "X Day Type Over Z Spells In Y Period Type",
        properties: {
          spells: {
            type: "integer",
            title: "Spells",
          },
          days: {
            type: "integer",
            title: "Days",
          },
          dayType: findSchemaPropertyByName(
            typeSchema,
            "xDayTypeOverZSpellsInYPeriodType",
            "dayType",
          ),
          period: {
            type: "integer",
            title: "Period",
          },
          periodType: {
            title: "Period Type",
            type: "string",
            oneOf: [
              { title: "Days", const: "D" },
              { title: "Months", const: "M" },
              { title: "Weeks", const: "W" },
            ],
          },
          fteProRata: findSchemaPropertyByName(
            typeSchema,
            "xDayTypeOverZSpellsInYPeriodType",
            "fteProRata",
          ),
        },
        type: "object",
      },
    },
    required: [...baseSchema.required, "xDayTypeOverZSpellsInYPeriodType"],
  };
};

export const uiSchema = (t: (s: string) => string) => ({
  ...baseUiSchema(t),
  xDayTypeOverZSpellsInYPeriodType: {
    fteProRata: {
      "ui:title": t("ALERTS_ALERT_FTE_PRO_RATA_ADJUSTMENT"),
      "ui:widget": "toggle",
    },
  },
});

const schemas: Schemas = {
  schema,
  uiSchema,
};

export default schemas;
